<template>
  <Field :label="label">
    <div class="client-row">
      <EntitySearchDropdown
        ref="entitySearchDropdown"
        :current="current"
        :disabled="disabled"
        placeholder="Search by name or email"
        @select="selectSearchResult"
        @clear="clearSelectedEntity"
      />
      <Button type="secondary" :disabled="disabled" @click="clearSelectedEntity">
        {{ secondaryActionText }}
      </Button>
      <Button type="primary" :disabled="disabled" @click="showCreatePersonModal = true">
        Create Person
      </Button>
    </div>
    <p v-if="hint" class="hint">
      {{ hint }}
    </p>

    <StakeModal v-model="showCreatePersonModal">
      <NewPersonModal @onClose="showCreatePersonModal = false" @onAdd="handlePersonCreated" />
    </StakeModal>
  </Field>
</template>

<script>
import {
  Button,
  Field,
} from '@stakeui';
import StakeModal from '@stakeui/StakeModal.vue';
import NewPersonModal from '@frontend/ui/features/people/NewPersonModal.vue';
import EntitySearchDropdown from '@frontend/ui/components/utils/EntitySearchDropdown.vue';

export default {
  name: 'EntitySearchWithActions',
  components: {
    Button,
    EntitySearchDropdown,
    Field,
    NewPersonModal,
    StakeModal,
  },
  props: {
    label: {
      type: String,
      default: 'Client (optional)',
    },
    hint: {
      type: String,
      default: '',
    },
    current: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    secondaryActionText: {
      type: String,
      default: 'Cancel',
    },
  },
  data() {
    return {
      showCreatePersonModal: false,
    };
  },
  methods: {
    clearSelectedEntity() {
      if (this.$refs.entitySearchDropdown) {
        this.$refs.entitySearchDropdown.clearSearch();
      }
      this.$emit('clear');
    },
    selectSearchResult(option) {
      this.$emit('select', option || null);
    },
    handlePersonCreated(created) {
      this.showCreatePersonModal = false;
      if (!created?.external_id) {
        return;
      }
      this.$emit('select', {
        external_id: created.external_id,
        name: created.name || created.email || created.external_id,
        email: created.email || '',
      });
    },
  },
};
</script>

<style scoped>
.client-row {
  display: flex;
  gap: var(--stk-size-3);
  align-items: center;
}

.client-row > :first-child {
  flex: 1;
}

.hint {
  color: var(--stk-color-text-muted);
  font-size: 0.85rem;
}
</style>
